export default __webpack_public_path__ + "static/media/5_Serverless_Powerups_for_your_DevOps_Infrastructure_in_5_minutes_DevOps_Days_Cairo.0f7cfd15.png";